export const PLANS = [
  {
    id: 'starter',
    name: 'Başlangıç',
    monthlyPrice: 750,
    yearlyPrice: 7500,
    monthlyPriceUSD: 19,
    yearlyPriceUSD: 190,
    description: 'Tırnak bakım merkezleri, kuaförler, tek çalışanlı stüdyolar',
    features: {
      appointments: false,
      loyalty: false,
      tracking: false,
      maxStaff: 3,
      customDomain: false,
      prioritySupport: false,
      sms: false,
      smsMonthlyLimit: 0,
      satisfactionSms: false,
      packages: false,
      commissions: false,
      stock: false,
    },
    highlights: [
      'Adisyon yönetimi',
      'Müşteri & çalışan listesi',
      'Temel gelir/gider raporu',
      'Temel Randevu Sistemi (işletme için)',
      'Maks 3 personel',
    ],
  },
  {
    id: 'pro',
    name: 'Profesyonel',
    monthlyPrice: 1200,
    yearlyPrice: 12000,
    monthlyPriceUSD: 29,
    yearlyPriceUSD: 290,
    description: 'Orta ölçekli salonlar, kuaförler',
    features: {
      appointments: true,
      loyalty: true,
      tracking: true,
      maxStaff: null,
      customDomain: false,
      prioritySupport: false,
      sms: true,
      smsMonthlyLimit: 500,
      satisfactionSms: true,
      packages: true,
      commissions: true,
      stock: true,
    },
    highlights: [
      "Başlangıç'ın tüm özellikleri",
      'Gelişmiş Randevu Sistemi (misafir randevu talebi)',
      'Sadakat (Loyalty) Sistemi',
      'Paket & Seans Takibi',
      'Stok Yönetimi',
      'Prim Sistemi',
      'SMS Randevu Hatırlatma (yakında)',
      'Sınırsız personel',
    ],
    popular: true,
  },
  {
    id: 'premium',
    name: 'Premium',
    monthlyPrice: 2500,
    yearlyPrice: 25000,
    monthlyPriceUSD: 69,
    yearlyPriceUSD: 690,
    description: 'Lazer merkezleri, klinikler, büyük salonlar',
    features: {
      appointments: true,
      loyalty: true,
      tracking: true,
      maxStaff: null,
      customDomain: true,
      prioritySupport: true,
      sms: true,
      smsMonthlyLimit: 2000,
      satisfactionSms: true,
      packages: true,
      commissions: true,
      stock: true,
    },
    highlights: [
      "Profesyonel'in tüm özellikleri",
      'Özel alan adı — randevu sayfası',
      'Özel alan adı — uygulama girişi',
      'Öncelikli destek',
      'SMS 2.000/ay (yakında)',
      'WhatsApp Bildirim (yakında)',
      'Çoklu Şube Yönetimi (yakında)',
    ],
  },
];

export const getPlan = (planId) =>
  PLANS.find((p) => p.id === planId) || PLANS.find((p) => p.id === 'pro');

export const getPlanPrice = (planId, billingCycle) => {
  const plan = getPlan(planId);
  return billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice;
};

/**
 * Display-only helper: dil 'en' ise USD, değilse TRY döndürür.
 * Arka planda ödeme mantığı değişmez.
 */
export const getPlanPriceDisplay = (planId, billingCycle, lang) => {
  const plan = getPlan(planId);
  const isEN = lang === 'en';
  if (isEN) {
    const amount = billingCycle === 'yearly' ? plan.yearlyPriceUSD : plan.monthlyPriceUSD;
    return {
      amount,
      formatted: amount.toLocaleString('en-US'),
      symbol: '$',
      symbolBefore: true,
      yearlyMonthlyEquivFormatted: Math.round(plan.yearlyPriceUSD / 12).toLocaleString('en-US'),
      baseMonthlyFormatted: plan.monthlyPriceUSD.toLocaleString('en-US'),
    };
  }
  const amount = billingCycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice;
  return {
    amount,
    formatted: amount.toLocaleString('tr-TR'),
    symbol: '₺',
    symbolBefore: false,
    yearlyMonthlyEquivFormatted: Math.round(plan.yearlyPrice / 12).toLocaleString('tr-TR'),
    baseMonthlyFormatted: plan.monthlyPrice.toLocaleString('tr-TR'),
  };
};
